"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decrypt = decrypt;
exports.encrypt = encrypt;
exports.generateKey = generateKey;
exports.verifyHmac = verifyHmac;

var crypto = _interopRequireWildcard(require("@walletconnect/crypto"));

var encoding = _interopRequireWildcard(require("@walletconnect/encoding"));

var _utils = require("@walletconnect/utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

async function generateKey(length) {
  const _length = (length || 256) / 8;

  const bytes = crypto.randomBytes(_length);
  const result = (0, _utils.convertBufferToArrayBuffer)(encoding.arrayToBuffer(bytes));
  return result;
}

async function verifyHmac(payload, key) {
  const cipherText = encoding.hexToArray(payload.data);
  const iv = encoding.hexToArray(payload.iv);
  const hmac = encoding.hexToArray(payload.hmac);
  const hmacHex = encoding.arrayToHex(hmac, false);
  const unsigned = encoding.concatArrays(cipherText, iv);
  const chmac = await crypto.hmacSha256Sign(key, unsigned);
  const chmacHex = encoding.arrayToHex(chmac, false);

  if (encoding.removeHexPrefix(hmacHex) === encoding.removeHexPrefix(chmacHex)) {
    return true;
  }

  return false;
}

async function encrypt(data, key, providedIv) {
  const _key = encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));

  const ivArrayBuffer = providedIv || (await generateKey(128));
  const iv = encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(ivArrayBuffer));
  const ivHex = encoding.arrayToHex(iv, false);
  const contentString = JSON.stringify(data);
  const content = encoding.utf8ToArray(contentString);
  const cipherText = await crypto.aesCbcEncrypt(iv, _key, content);
  const cipherTextHex = encoding.arrayToHex(cipherText, false);
  const unsigned = encoding.concatArrays(cipherText, iv);
  const hmac = await crypto.hmacSha256Sign(_key, unsigned);
  const hmacHex = encoding.arrayToHex(hmac, false);
  return {
    data: cipherTextHex,
    hmac: hmacHex,
    iv: ivHex
  };
}

async function decrypt(payload, key) {
  const _key = encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));

  if (!_key) {
    throw new Error("Missing key: required for decryption");
  }

  const verified = await verifyHmac(payload, _key);

  if (!verified) {
    return null;
  }

  const cipherText = encoding.hexToArray(payload.data);
  const iv = encoding.hexToArray(payload.iv);
  const buffer = await crypto.aesCbcDecrypt(iv, _key, cipherText);
  const utf8 = encoding.arrayToUtf8(buffer);
  let data;

  try {
    data = JSON.parse(utf8);
  } catch (error) {
    return null;
  }

  return data;
}